export default __webpack_public_path__ + "static/media/yomafleet_car_share.e9d4e157.png";